<template>
  <div class="filter">
    <el-steps :active="nowactive" v-show="active!=1" finish-status="success" style="position: relative;width: 880px;margin-left:60px;">
      <div class="step1" @click="changeindex(1)"></div>
      <el-step title="处理中" description="可输入您的处理意见或指派处理人员">

      </el-step>
      <div class="step2" @click="changeindex(2)"></div>
      <el-step title="已排查" description="可输入您的排查过程和排查结论，建议专业人员排查"></el-step>
      <div class="step3" @click="changeindex(3)"></div>
      <el-step title="已处置" description="请确定您的线路问题已解决"></el-step>
    </el-steps>
    <div class="main-con">
      <div class="step-one" v-show="active==0">
        <el-input
          type="textarea"
          :rows="10"

          placeholder="请输入内容"

          v-model="steponetext"
        >
        </el-input>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn" @click="finconfirm">提 交</el-button>

      </span>
      </div>
      <div class="step-one" v-show="active==2">
        <el-input
          type="textarea"
          :rows="4"

          placeholder="请输入内容"

          v-model="steponetext"
        >
        </el-input>
        <div class="checkbox">
          <p>针对该事件，如您有以下反馈，欢迎填写：</p>
          <div class="radio">
            <span class="em">报警原因</span>

              <el-radio v-model="eventReason" label="1">异常用电</el-radio>
              <el-radio v-model="eventReason" label="2">存在隐患</el-radio>
              <el-radio v-model="eventReason" label="3">存在误报源</el-radio>


          </div>
          <div class="radio">
            <span class="em">阈值反馈</span>
            <el-radio-group v-model="thresholdFeedback">
              <el-radio :label="1"
              >合理<span style="color: rgba(0, 0, 0, 0)">合理</span></el-radio
              >
              <el-radio :label="2">不合理</el-radio>
            </el-radio-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer" >
        <div class="footer__title">
          <img src="../unusualCenterPage/img/historyIcon.png" />
          <p>处理历史</p>
        </div>
        <div class="step">
          <el-timeline
            v-for="(activity, index) in activities"
            :reverse="true"
            :key="index"
          >
            <el-timeline-item
              :timestamp="activity.createTime"
              placement="top"
              color="#2A62FF"
            >
              <div class="timeline">
                <span class="measure">{{ activity.measure }}</span>

                <span class="handlerName">
                  <i
                    :style="
                      activity.status == '处理中'
                        ? 'color:#2A62FF'
                        : 'color:#252B3C'
                    "
                  >{{ activity.handleStatusName}}</i
                  >
                  <p>{{ activity.handlerName }}</p></span
                >
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </span>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn" @click="finconfirm">提 交</el-button>
        </span>
      </div>
      <div class="step-one" v-show="active==3">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="steponetext"
        >
        </el-input>

        <span slot="footer" class="dialog-footer" >
        <div class="footer__title">
          <img src="../unusualCenterPage/img/historyIcon.png" />
          <p>处理历史</p>
        </div>
        <div class="step">
            <el-timeline
              v-for="(activity, index) in activities"
              :reverse="true"
              :key="index"
            >
            <el-timeline-item
              :timestamp="activity.createTime"
              placement="top"
              color="#2A62FF"
            >
              <div class="timeline">
                <span class="measure">{{ activity.measure }}</span>

                <span class="handlerName">
                  <i
                    :style="
                      activity.status == '处理中'
                        ? 'color:#2A62FF'
                        : 'color:#252B3C'
                    "
                  >{{ activity.handleStatusName }}</i
                  >
                  <p>{{ activity.handlerName }}</p></span
                >
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </span>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="btn" @click="finconfirm">提 交</el-button>
        </span>
      </div>
      <div class="step-one" v-show="active==1">


        <span slot="footer" class="dialog-footer" >
        <div class="footer__title">
          <img src="../unusualCenterPage/img/historyIcon.png" />
          <p>处理历史</p>
        </div>
        <div class="step">
             <el-timeline
               v-for="(activity, index) in activities"
               :reverse="true"
               :key="index"
             >
            <el-timeline-item
              :timestamp="activity.createTime"
              placement="top"
              color="#2A62FF"
            >
              <div class="timeline">
                <span class="measure">{{ activity.measure }}</span>

                <span class="handlerName">
                  <i
                    :style="
                      activity.status == '处理中'
                        ? 'color:#2A62FF'
                        : 'color:#252B3C'
                    "
                  >{{ activity.handleStatusName }}</i
                  >
                  <p>{{ activity.handlerName }}</p></span
                >
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </span>

      </div>
    </div>

  </div>
</template>

<script>
import Axios from "../../utils/Axios";

export default {
  name: "fFilter",
  props: {
    eventid:"",
    dealshow:null,
  },
  data() {
    return {
      active:"0",
      nowactive:"0",
      normalNum:"0",
      steponetext:"",
      otherReasonDesc:"",
      thresholdFeedback:"",
      newactive:"",
      eventReason:"",
      eventReasonCodeList: [],
      activities: [],
      cities: [
        { label: "监测点存在误报源", value: 1 },
        { label: "监测点存在隐患", value: 2 },

        { label: "其他", value: 255 },
      ],
    };
  },
  methods: {
    clear(){
      this.nowactive=0
      this.normalNum=0
      this.steponetext=""
      this.eventReason=""
      this.thresholdFeedback=""
    },
    changeindex(index){
    if(index > this.normalNum){
      if(index==1){
        this.active=0

      }else if(index==2){
        this.active=2
      }else if(index==3){
        this.active=3
      }
      this.nowactive=index - 1
    }

    },
    confirm2() {
      const param = {
        url: "/event/handleDetail",
        method: "post",
        data: {
          id:this.eventid,

        },
      };
      Axios.ajax(param).then((res) => {
        if (res.resultCode == 0) {


          if(res.data.handleStatus == 0){
            this.nowactive=0
            this.normalNum=0
          }else   if(res.data.handleStatus == 2){
            this.nowactive=1
            this.normalNum=1
          }else   if(res.data.handleStatus == 3){
            this.nowactive=2
            this.normalNum=2
          }else   if(res.data.handleStatus == 1){
            this.nowactive=3
            this.normalNum=3
          }

          this.active=res.data.handleStatus

          this.activities=res.data.handleHistories
        } else {
          this.$message({
            type: "error",
            message: res.resultMessage,
          });


        }
      });
    },
    finconfirm() {
      var data
      var handleStatus

      if(this.nowactive==0){
        handleStatus=2
      }else if(this.nowactive==1){
        handleStatus=3
      }else if(this.nowactive==2){
        handleStatus=1
      }
      data={
        id:this.eventid,
        "eventReason": Number(this.eventReason),
        "handleStatus":handleStatus,
        "measure": this.steponetext,
        "thresholdFeedback": this.thresholdFeedback
      }
      const param = {
        url: "/event/handle",
        method: "post",
        data: data,
      };
      Axios.ajax(param).then((res) => {
        if (res.resultCode == 0) {
          this.$message({
            type: "success",
            message: "处置成功",
          });
          this.$emit('showdeal', false)
        } else {
          this.$message({
            type: "error",
            message: res.resultMessage,
          });
        }
      });
    },

  },
  created() {

  },
  mounted() {
    this.clear()
    this.confirm2()

  },
  watch:{
    eventid(){
      this.clear()
this.confirm2()

    },
    dealshow(){
      this.clear()
      this.confirm2()
    }
  }
};
</script>

<style lang="less" scoped>
.filter {
  padding-bottom: 30px;
  width: 920px;

}
.dialog-footer{
  height: 20px;
  display: inline-block;
  float: right;
  margin-top: 10px;
  width: 100%;
}
.step1{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.step2{
  position: absolute;
  top: 0;
  left: 370px;
  z-index: 1000;
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.step3{
  position: absolute;
  top: 0;
  left: 740px;
  z-index: 1000;
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.main-con{
  padding-top: 30px;
  padding-bottom: 30px;
  width: 100%;
  min-height: 400px;
  .btn{


    margin-top: 0px;
    float: right;
    margin-right: 20px;
  }
}
.checkbox {
  p {
    margin: 20px 0;
    font-size: 14px;
    font-family: OPPOSans-M, OPPOSans;
    font-weight: normal;
    color: #252b3c;
    line-height: 24px;
  }
  .radio {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .em {
      font-size: 14px;
      font-family: OPPOSans-R, OPPOSans;
      font-weight: normal;
      color: #252b3c;
      line-height: 24px;
      margin-right: 32px;
    }
    .el-radio__label {
      color: #7d879f;
    }
  }
}
.footer__title {
  margin: 16px 4px;
  display: flex;
  p {
    margin-left: 12px;
    font-size: 16px;
    color: #252b3c;
  }
}
.step {
  font-size: 14px;
  color: #252b3c;
  overflow: auto;
  max-height: 251px;
  padding: 10px;
  .timeline {
    display: flex;
    justify-content: space-between;
  }
  .el-timeline-item__tail {
    display: block;
    border-left: 1px solid rgba(42, 98, 255, 0.3);
  }
  .measure {
    width: 80%;
  }
  .handlerName {
    width: 15%;
    min-height: 50px;
    position: relative;
    i {
      position: absolute;
      top: -20px;
    }
    p {
      position: absolute;
      bottom: 0;
    }
  }
}

</style>
<style>
.filter .el-step__description {
  position: relative;
  left: -58px;
}
</style>
